import { Component, OnInit } from '@angular/core';
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../store';
import { TILE_CLICKED, UNHOVER_TILE, HOVER_TILE } from '../actions';
import { Point } from '../point';
import { TileType, isValueTile } from '../tile';
import * as SvgPanZoom from 'svg-pan-zoom';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})

export class MapComponent implements OnInit {
  @select() map;
  @select() editorType;
  @select() highlightedTiles;
  @select() terrainEditorEnabled;
  @select() activeTerrain;

  svgPanZoomInstance = null;
  panning = false;
  _highlightedTiles = [];
  _terrainEditorEnabled = false;
  _activeTerrain = false;

  constructor(private ngRedux: NgRedux<IAppState>) {
  }

  ngOnInit() {
    this.highlightedTiles.subscribe(tiles => {
      if (!tiles) {
        this._highlightedTiles = [];
        return;
      };

      this._highlightedTiles = tiles.map(t => t.x + "/" + t.y);
    });

    this.terrainEditorEnabled.subscribe(t => {
      this._terrainEditorEnabled = t;
    });
    this.activeTerrain.subscribe(t => {
      this._activeTerrain = t;
    });

  }
  
  ngAfterViewInit() {
    // initializing the function
    this.svgPanZoomInstance = SvgPanZoom('#tilemap', {
      minZoom: 0.1,
      maxZoom: 1,
      dblClickZoomEnabled: false,
      fit: false,
      contain: false,
      center: true,
      beforePan: () => {
        this.panning = true;
      }
    });
    this.svgPanZoomInstance.zoom(0.5);
  }

  log(msg) {
    console.log(msg);
  }

  onTileHover(x, y) {
    this.ngRedux.dispatch({
      type: HOVER_TILE,
      payload: {
        point: {x: x, y: y}
      }
    });
  }

  onTileUnHover() {
    this.ngRedux.dispatch({
      type: UNHOVER_TILE
    });
  }

  onTileClick(x, y) {
    if (!this.panning) {
      this.setTile(x, y);
    }
    else {
      this.panning = false;
    }
  }

  setTile(x, y) {
    this.ngRedux.dispatch({
      type: TILE_CLICKED,
      payload: {
        point: {x: x, y: y}
      }
    });
  }

  getScreenCoords(x, y) {
    return {
      x: x + 0.5 * y,
      y: y
    };
  }

  getPixelCoords(x, y) {
    let screenCoords = this.getScreenCoords(x, y);

    return {
      x: screenCoords.x * 194, // + (y % 2 ? 97 : 0), //  97 * 2 + (y % 2 ? 97 : 0),
      y: screenCoords.y * 167.99107071667768 // (112 + Math.sqrt(Math.pow(112, 2) - Math.pow(97, 2)))
    };
  }

  getPolygonPointsAt(x, y) {
    let coords = this.getPixelCoords(x, y);

    // Hexagon
    //                 5 (0, 112)
    //             /       \
    //  (-97, 56) 4         0 (97, 56)
    //            |   0,0   |
    // (-97, -56) 3         1 (97, -56)
    //             \       /
    //                 2 (0, -112)
    
    // outerRadius: 112
    // innerRadius: 97

    return [
      (coords.x + 97)       + ',' + (coords.y + 56),  // 0
      (coords.x + 97)       + ',' + (coords.y - 56),  // 1
      (coords.x + 0)        + ',' + (coords.y - 112), // 2
      (coords.x - 97)       + ',' + (coords.y - 56),  // 3
      (coords.x - 97)       + ',' + (coords.y + 56),  // 4
      (coords.x + 0)        + ',' + (coords.y + 112)  // 5
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/map/map.component.ts